import { render, staticRenderFns } from "./TransferAccountCreateUpdate.vue?vue&type=template&id=39208db4&scoped=true&"
import script from "./TransferAccountCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./TransferAccountCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccountCreateUpdate.vue?vue&type=style&index=0&id=39208db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39208db4",
  null
  
)

export default component.exports